var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKpiLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 118 121",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 3.5A58.5 58.5 0 01117.5 62 58.5 58.5 0 0159 120.5 58.5 58.5 0 01.5 62 58.5 58.5 0 0159 3.5z",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7 77a.8.8 0 01-.2-.4V57.1a.8.8 0 01.6-.8h4.5l.4.3.2.5v19.4c-.3.4-.3.8-.6.8H77l-.4-.2zm-11.3 0V64.6c0-.3.4-.5.7-.5h4.4c.3 0 .6.2.6.5V77c-.3.3-.3.5-.6.5h-4.4c-.3 0-.7-.2-.7-.5zM54 76.4V55c0-.4.3-.8.6-.8H59c.4 0 .7.4.7.8v21.4c-.3.4-.3.9-.7.9h-4.4c-.3 0-.6-.5-.6-.9zm-11.1-.1v-36c0-.4.3-1 .6-1H48c.3 0 .6.6.6 1v36c0 .4-.3 1-.6 1h-4.5c-.3 0-.6-.6-.6-1zm45.4 7l.2.4v4.2c0 .1 0 .3-.2.4l-.4.2H32a.7.7 0 01-.6-.6V36c0-.1 0-.3.2-.4l.4-.2h4.1a.7.7 0 01.7.6v47h51l.4.1z",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5.5a25 25 0 110 50 25 25 0 010-50zm10.3 24.2h-2V18c0-2.2-1.8-3.9-4-3.9h-7.4a3.8 3.8 0 00-3.8 3.9v6.7h-2a1 1 0 00-1 1v11.5c0 .5.4 1 1 1h19.2c.5 0 1-.5 1-1V25.7c0-.6-.5-1-1-1zm-15-6.7c0-1 .7-1.7 1.6-1.7H97c.9 0 1.6.7 1.6 1.7v6.7H87.8zm13.8 18H84.7v-9.1h16.9zm-9.3-4.2v1.6l.2.3h1.2c.2 0 .3-.2.3-.3v-1.6a1.4 1.4 0 10-1.7 0z",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpiLocked);
export default __webpack_public_path__ + "static/media/kpi-locked.56206fa9.svg";
export { ForwardRef as ReactComponent };